import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";
import { css } from "@emotion/core";
import moment from "moment";
import "react-dates/initialize";
import { SingleDatePicker } from "react-dates";
import "react-dates/lib/css/_datepicker.css";
import { Button, Form, Input, Alert, FormGroup, Label } from "reactstrap";
import { BounceLoader } from "react-spinners";
import { base_URL } from "../config/buildSettings.js";
import { apiKey } from "../config/index.js";

const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;

const options = {
  year: "numeric",
  month: "long",
  day: "numeric",
};

class AdminRound extends Component {
  constructor(props) {
    super(props);

    this.handleInputChange = this.handleInputChange.bind(this);
    this.toggleMessageAlert = this.toggleMessageAlert.bind(this);
    this.toggleErrorAlert = this.toggleErrorAlert.bind(this);
    this.handleEnterClick = this.handleEnterClick.bind(this);
    this.getCurrentRound = this.getCurrentRound.bind(this);
    this.updateRound = this.updateRound.bind(this);

    this.state = {
      isAuthenticated: false,
      currentRound: {},
      round: "",
      begin_date: moment(),
      end_date: moment(),
      loading: true,
      warn: false,
      error: "",
      message: "",
      showMessageAlert: false,
      showErrorAlert: false
    };
  }

  componentDidMount() {
    this.getCurrentRound();
  }

  toggleErrorAlert() {
    this.setState({
      showErrorAlert: !this.state.showErrorAlert,
      error: ""
    });
  }

  toggleMessageAlert() {
    this.setState({
      showMessageAlert: !this.state.showMessageAlert,
      message: ""
    });
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  handleEnterClick(event) {
    event.preventDefault();
    this.setState({ warn: true });
  }


  getCurrentRound() {
    let url;
    url = `${base_URL}/api/internal/getround`;

    console.log(url);

    fetch(url, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        apiKey: apiKey
      })
    })
      .then(response => {
        console.log(response);
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response;
      })
      .then(response => response.json())
      .then(json => {
        console.log(json);
        var old = JSON.stringify(json).replaceAll('T00:00:00', ''); //convert to JSON string
        var newArray = JSON.parse(old); //convert back to array
        this.setState({
          currentRound: newArray,
          round: newArray[0].Round_Name,
          begin_date: moment(newArray[0].Round_Begin),
          end_date: moment(newArray[0].Round_End),
          loading: false
        });
      })
      .catch(error => {
        console.error(error);
        this.setState({
          error: error.message, showErrorAlert: true, warn: false, loading: false
        });
      });
  }

  updateRound() {
    let url;
    url = `${base_URL}/api/internal/updateround`;

    console.log(url);

    fetch(url, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        round: this.state.round,
        begin_date: this.state.begin_date,
        end_date: this.state.end_date,
        username: this.props.username,
        apiKey: apiKey
      })
    })
      .then(response => {
        console.log(response);
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response;
      })
      .then(response => response.json())
      .then(json => {
        console.log(json);
        this.setState({
          message: json,
          showMessageAlert: true,
          warn: false
        });
        this.getCurrentRound();
      })
      .catch(error => {
        console.error(error);
        this.setState({ error: error.message, showErrorAlert: true, warn: false });
      });
  }

  render() {
    return (
      this.state.loading === false && (
        <Container style={{ textAlign: "center" }}>
          <Row>
            <Col>
              <br />
              <h4>Set the Public Summary Round Dates</h4>
              <br />
              {this.state.error !== "" && (
                <Col md={{ size: 6, offset: 3 }}>
                  <Alert
                    color="warning"
                    isOpen={this.state.showErrorAlert}
                    toggle={this.toggleErrorAlert}
                  >
                    {this.state.error}
                  </Alert>
                </Col>
              )}
              {this.state.message !== "" && (
                <Col md={{ size: 6, offset: 3 }}>
                  <Alert
                    color="info"
                    isOpen={this.state.showMessageAlert}
                    toggle={this.toggleMessageAlert}
                  >
                    {this.state.message}
                  </Alert>
                </Col>
              )}
            </Col>
          </Row>
          <Row>
            <Col>
              {this.state.currentRound[0] && (
                <span>Current Round: <strong>{this.state.currentRound[0].Round_Name}</strong> ({this.state.currentRound[0].Round_Begin} to {this.state.currentRound[0].Round_End})</span>
              )}
            </Col>
          </Row>
          <br />
          <Form onSubmit={this.handleEnterClick}>
            <Row form>
              <Col
                md={{ size: 3, offset: 4 }}
                style={{ marginBottom: "1rem" }}
              >
                <FormGroup>
                  <Label for="round">Round Name</Label>
                  <Input
                    type="text"
                    name="round"
                    id="round"
                    value={this.state.round}
                    onChange={this.handleInputChange}
                    placeholder="Round Name"
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row form>
              <Col
                md={{ size: 4, offset: 1 }}
                style={{ marginBottom: "1rem" }}
              >
                <FormGroup>
                  <Label for="beginDateInput">Round Begin Date</Label>
                  <br />
                  <SingleDatePicker
                    date={this.state.begin_date}
                    onDateChange={(begin_date) =>
                      this.setState({ begin_date: begin_date, data: {} })
                    }
                    focused={this.state.begin_dateFocused}
                    onFocusChange={({ focused }) =>
                      this.setState({ begin_dateFocused: focused })
                    }
                    isOutsideRange={(day) => false}
                    renderMonthElement={renderMonthElement}
                    numberOfMonths={1}
                    id="beginDateInput"
                    block={true}
                  />
                </FormGroup>
              </Col>
              <Col
                md={{ size: 4 }}
                style={{ marginBottom: "1rem" }}
              >
                <FormGroup>
                  <Label for="endDateInput">Round End Date</Label>
                  <br />
                  <SingleDatePicker
                    date={this.state.end_date}
                    onDateChange={(end_date) =>
                      this.setState({ end_date: end_date, data: {} })
                    }
                    focused={this.state.end_dateFocused}
                    onFocusChange={({ focused }) =>
                      this.setState({ end_dateFocused: focused })
                    }
                    isOutsideRange={(day) => false}
                    renderMonthElement={renderMonthElement}
                    numberOfMonths={1}
                    id="endDateInput"
                    block={true}
                  />
                </FormGroup>
              </Col>
              <Col
                md={{ size: 3 }}
                style={{ display: "flex", alignItems: "center" }}
              >
                <Button type="submit" color="primary">
                  Update
                </Button>
              </Col>
            </Row>
            <br />
          </Form>

          {
            this.state.warn && (
              <Row>
                <Col>
                  <span>
                    {"  "}
                    <Button onClick={this.updateRound} color="danger">
                      Confirm
                    </Button>
                  </span>
                </Col>
              </Row>
            )
          }
        </Container >
      )

    );
  }
}

export default AdminRound;

const returnYears = () => {
  let years = [];
  for (let i = moment().year() - 15; i <= moment().year() + 1; i++) {
    years.push(
      <option key={i} value={i}>
        {i}
      </option>
    );
  }
  return years;
};

const renderMonthElement = ({ month, onMonthSelect, onYearSelect }) => (
  <div style={{ display: "flex", justifyContent: "center" }}>
    <div>
      <Input
        bsSize="sm"
        type="select"
        value={month.month()}
        onChange={(e) => onMonthSelect(month, e.target.value)}
      >
        {moment.months().map((label, value) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
      </Input>
    </div>
    <div>
      <Input
        bsSize="sm"
        type="select"
        value={month.year()}
        onChange={(e) => onYearSelect(month, e.target.value)}
      >
        {returnYears()}
      </Input>
    </div>
  </div>
);
